import React from 'react'
import classes from './style.module.scss'
import PropTypes from 'prop-types'
import { snackbarActions } from '@Root/store'
import { connect } from 'react-redux'
import { useNotificationAnimation } from '@Root/hooks'

export const Notification = ({ snackbar, changeHandler }) => {
	const { bottom, opacity, wait } = useNotificationAnimation(changeHandler, snackbar)
	return snackbar ? (
		<div
			className={classes.wrapper}
			style={{ bottom, opacity, transition: `all ${wait}ms ease-out`, backgroundColor: !snackbar.isError ? '#4a4a4a' : '#D0021B' }}
		>
			{snackbar.text}
		</div>
	) : (
		<></>
	)
}

Notification.propTypes = {
	text: PropTypes.string,
	changeHandler: PropTypes.func,
	isError: PropTypes.bool,
}

Notification.defaultProps = {
	text: null,
	changeHandler: () => {},
	isError: false,
}

const mapStateToProps = ({ snackbarReducer }) => ({
	snackbar: snackbarReducer.snackbar,
})
const mapDispatchToProps = dispatch => {
	return {
		changeHandler: data => dispatch(snackbarActions.setSnackbar(data)),
	}
}

export const Snackbar = connect(
	mapStateToProps,
	mapDispatchToProps
)(Notification)
